import { Typography, Box } from '@mui/material'
import { type Log, type Color } from 'src/types'
import { capitalizeFirst } from 'src/utils/stringUtils'

interface CueProps {
  log: Log
  color?: Color
  backgroundColor?: Color
  borderColor?: Color
  boxShadowColor?: Color
}

const style = {
  fontSize: '16px',
  padding: '4px 8px',
  width: 'fit-content'
}

const Cue = ({ log, color = 'white', backgroundColor = '#161124', borderColor = 'black', boxShadowColor = 'black' }: CueProps) => (
  <Box sx={
    {
      ...style,
      color,
      border: `1px solid ${borderColor}`,
      boxShadow: `4px 4px ${boxShadowColor}`,
      backgroundColor,
      '&:hover': {
        backgroundColor
      }
    }
    } className='cue'>
    <Typography
      color={color}
      id="modal-modal-title"
      textAlign="left"
      fontSize='1rem'
      fontStyle={log.author?.length ? 'normal' : 'italic'}
    >
      {log.author && log.author.length > 0 ? `${capitalizeFirst(log.author)}` : ''}
    </Typography>

    <Typography variant="body2" fontSize='1rem'>
      <span style={{
        color: log.omen === 'good'
          ? '#c4a26c'
          : log.omen === 'bad'
            ? '#e0959d'
            : log.omen === 'special'
              ? 'gold'
              : 'white'
      }}>
        {log.text}
      </span>
    </Typography>
  </Box>
)

export default Cue
